import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';

import {
  ContractId,
  IEmergencyContactExistsResponse,
  IEmergencyContactExistsResponseBean,
  IEmergencyContactsResponseBean,
  ResidentEmergencyContactType,
} from '../../../models';
import { emergencyContactsExistsQuery, getEmergencyContactsQuery } from '../../../queries';

@Injectable()
export class EmergencyContactsFacade {
  constructor(private apollo: Apollo) {}

  public emgergencyContactsExists(): Observable<IEmergencyContactExistsResponse> {
    return this.apollo
      .query<IEmergencyContactExistsResponseBean>({
        query: emergencyContactsExistsQuery,
      })
      .pipe(
        map(result => {
          if (typeof result.data?.emergencyContactExists?.emergencyContactExists === 'boolean') {
            return result.data.emergencyContactExists;
          }
          // In Apollo Client v4, errors are emitted via the error channel; reaching here means missing data
          throw new Error('Emergency contact exists response missing');
        })
      );
  }

  public getEmergencyContacts(
    contractId: ContractId,
    type: ResidentEmergencyContactType
  ): Observable<IEmergencyContactsResponseBean> {
    return this.apollo
      .query<{ getEmergencyContacts: IEmergencyContactsResponseBean }>({
        query: getEmergencyContactsQuery,
        variables: {
          contractId,
          type,
        },
      })
      .pipe(
        map(result => {
          if (result?.data?.getEmergencyContacts) {
            return result.data.getEmergencyContacts;
          }
          // In Apollo Client v4, errors are emitted via the error channel; reaching here means missing data
          throw new Error('Emergency contacts response missing');
        })
      );
  }
}
